import { useMemo } from 'react';
import { useOrganizationAccessLevel } from '@crehana/compass.knowledgehub';
import useIsPlayRoomActivated from '@crehana/compass.playroom/shared/hooks/useIsPlayRoomActivated';
import { useFlagOrganization } from "../../../../hooks/useFlagOrganization";
import { useLearning } from "../use-learning";
export var useExcludedCodes = function useExcludedCodes(props) {
  var organizationSlug = props.organizationSlug,
    organizationId = props.organizationId,
    email = props.email,
    isKnowledgeHubEnabled = props.isKnowledgeHubEnabled;
  var _useIsPlayRoomActivat = useIsPlayRoomActivated(organizationSlug),
    isPlayroomEnabled = _useIsPlayRoomActivat.isActivated;
  var _useLearning = useLearning({
      email: email
    }),
    myRole = _useLearning.myRole;
  var _useFlagOrganization = useFlagOrganization({
      flag: 'NEW_HIGHER_EDUCATION_HOME_USER',
      organizationSlug: organizationSlug
    }),
    hideMarketplaceUIFF = _useFlagOrganization.isActive,
    loadingMarketplace = _useFlagOrganization.isLoading;
  var _useOrganizationAcces = useOrganizationAccessLevel({
      orgId: organizationId,
      skip: organizationId === -1
    }),
    isPureLMSOrganization = _useOrganizationAcces.isPureLMSOrganization,
    isLoadingPureLMSOrganization = _useOrganizationAcces.loading;
  var isMarketplaceUser = myRole === 'high-education-member';
  var hideMarketplaceNavbarMenu = isMarketplaceUser && hideMarketplaceUIFF;
  var isLoading = loadingMarketplace || isLoadingPureLMSOrganization;
  var codesToExclude = useMemo(function () {
    var excludedCodes = [];
    if (!isKnowledgeHubEnabled) {
      excludedCodes.push('LEARNING.CATALOG');
    }
    if (!isPlayroomEnabled) {
      excludedCodes.push('LEARNING.GAMIFICATION');
    }
    if (isPureLMSOrganization) {
      excludedCodes.push('LEARNING.MENTORSHIP');
    }
    if (hideMarketplaceNavbarMenu) {
      excludedCodes.push('LEARNING.SKILL_XP_EVOLUTION');
    }
    return excludedCodes;
  }, [isPlayroomEnabled, isPureLMSOrganization, isKnowledgeHubEnabled, hideMarketplaceNavbarMenu]);
  return {
    codesToExclude: codesToExclude,
    isLoading: isLoading
  };
};